import React from 'react';
import styles from './credits.css';

const CreditsPage = () => (
    <div className={styles.container}>
        <div className={styles.content}>
            <h1>Créditos y Código Fuente</h1>

            <section>
                <h2>Coding Board Studio</h2>
                <p>
          Plataforma de programación visual para niños desarrollada por
          Coding Board.
                </p>
            </section>

            <section>
                <h2>Basado en Scratch</h2>
                <p>
          Coding Board Studio es un fork de{' '}
                    <a
                        href="https://github.com/scratchfoundation/scratch-gui"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
            scratch-gui
                    </a>
          , desarrollado por el MIT Media Lab y la Scratch Foundation.
          Scratch es una marca registrada del MIT.
                </p>
            </section>

            <section>
                <h2>Licencia</h2>
                <p>
          Coding Board Studio está licenciado bajo{' '}
                    <a
                        href="https://www.gnu.org/licenses/agpl-3.0.html"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
            GNU Affero General Public License v3.0
                    </a>
          .
                </p>
                <p>
          El código fuente completo, incluyendo todas nuestras
          modificaciones, está disponible públicamente en:
                </p>
                <p className={styles.repoLink}>
                    <a
                        href="https://github.com/coding-board/scratch-gui"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
            https://github.com/coding-board/scratch-gui
                    </a>
                </p>
            </section>

            <section>
                <h2>Contacto</h2>
                <p>
          Para más información:{' '}
                    <a href="mailto:hola@codingboard.mx">hola@codingboard.mx</a>
                </p>
            </section>

            <p className={styles.backLink}>
                <a href="/">← Volver al Studio</a>
            </p>
        </div>
    </div>
);

export default CreditsPage;
